import type { ReactNode } from 'react';

import { ChkGenericLoader } from '@ui/checkout-components';
import type { ObjectValues } from '@utility/typescript-generics';

import { TRANSLATION_KEYS } from '../utils/TranslationKeys';
import { AccountSelectionView } from '../views/AccountSelectionView/AccountSelectionView';
import { AuthenticationMethodsView } from '../views/AuthenticationMethodsView/AuthenticationMethodsView';
import { DecoupledVerificationView } from '../views/DecoupledVerificationView/DecoupledVerificationView';
import { LoginView } from '../views/LoginView/LoginView';
import { VerificationView } from '../views/VerificationView/VerificationView';
import { WaitingForVerificationStatusView } from '../views/WaitingForVerificationStatusView';

export const FIELDS_TO_VIEW_MAP: Record<string, ReactNode> = {
  'SCA_USERNAME-SCA_PASSWORD': <LoginView />,
  SCA_METHOD: <AuthenticationMethodsView />,
  SCA_CODE: <VerificationView />,
  AWAITING_DECOUPLED_AUTHORISATION: <DecoupledVerificationView />,
  AWAITING_USER_REDIRECT: <ChkGenericLoader />,
  AWAITING_REDIRECT_URL: <WaitingForVerificationStatusView />,
  ACCOUNT: <AccountSelectionView />,
} as const satisfies Record<string, ReactNode>;

export const FIELDS_TO_TITLE_MAP: Record<
  string,
  ObjectValues<typeof TRANSLATION_KEYS>
> = {
  'SCA_USERNAME-SCA_PASSWORD': TRANSLATION_KEYS.LOGIN_VIEW_TITLE,
  SCA_METHOD: TRANSLATION_KEYS.AUTHENTICATION_METHOD_VIEW_TITLE,
  SCA_CODE: TRANSLATION_KEYS.VERIFICATION_CODE,
  AWAITING_DECOUPLED_AUTHORISATION:
    TRANSLATION_KEYS.AWAITING_DECOUPLED_AUTHORISATION_VIEW_TITLE,
  AWAITING_USER_REDIRECT: TRANSLATION_KEYS.REDIRECT_VIEW_TITLE,
  AWAITING_REDIRECT_URL: TRANSLATION_KEYS.WAITING_FOR_VERIFICATION_VIEW_TITLE,
  ACCOUNT: TRANSLATION_KEYS.ACCOUNT_SELECTION_VIEW_TITLE,
} as const satisfies Record<
  keyof typeof FIELDS_TO_VIEW_MAP,
  ObjectValues<typeof TRANSLATION_KEYS>
>;

export const TITLE_DEBOUNCE_DELAY_IN_MS = 1000 as const;
